export enum CustomDomainTarget {
  dashboard = 'dashboard',
  supportCenter = 'support_center',
  email = 'email',
  trackingCode = 'tracking_code',
}

export enum CustomDomainType {
  dashboard = 'dashboard',
  supportCenter = 'support_center',
  trackingCode = 'tracking_code',
}

export enum CustomDomainItemStatus {
  provisioned = 'provisioned',
  pending = 'pending',
  failed = 'failed',
}

export enum CustomDomainPlatformType {
  AWL = 'awl',
  AAAS = '3as',
  STANDALONE = 'standalone',
}

export type PayloadResponse<T> = {
  payload: T;
};

export type DNSRecordType = 'A' | 'AAAA' | 'CNAME' | 'TXT' | 'TXTContains' | 'MX' | 'NS';

export type DNSRecord = {
  type: DNSRecordType;
  name: string;
  value: string;
};

export enum CustomDomainProvisioningStatus {
  pending = 'pending',
  active = 'active',
  failed = 'failed',
  cancelled = 'cancelled',
}

export type CustomDomainRecord = {
  id: number;
  companyId: string;
  platform: CustomDomainPlatformType;
  domain: string;
  domainType: CustomDomainTarget;
  step: string;
  status: CustomDomainProvisioningStatus;
  createAt: string;
};

export type CreateCompanyDomainInput = {
  companyId: string;
  domain: string;
  platform: CustomDomainPlatformType;
  type: CustomDomainType;
  skipActivation?: boolean;
};

export type CreateWebsiteDomainInput = {
  websiteId: string;
  domain: string;
  platform: CustomDomainPlatformType;
  type: CustomDomainType;
  skipActivation?: boolean;
};

export type CancelPendingCompanyDomainInput = {
  companyId: string;
  customDomainId: number;
};

export type CancelPendingWebsiteDomainInput = {
  websiteId: string;
  customDomainId: number;
};

export type CreateOrUpdateAgencyCustomSubdomainInput = {
  agencyId: string;
  customUrl: string;
};

export type ActivateCompanyDomainInput = {
  companyId: string;
  customDomainId: number;
};

export type ActivateWebsiteDomainInput = {
  websiteId: string;
  customDomainId: number;
};

export type DeleteCompanyDomainInput = {
  companyId: string;
  customDomainId: number;
};

export type DeleteWebsiteDomainInput = {
  websiteId: string;
  customDomainId: number;
};

export type ListCompanyDomainsByTypeInput = {
  companyId: string;
  type: CustomDomainType;
};

export type ListCompanyDomainsByTypeResponsePayload = {
  active: CustomDomainRecord | null;
  pending: CustomDomainRecord | null;
  inactive: CustomDomainRecord[];
};

export type ListWebsiteDomainsByTypeInput = {
  websiteId: string;
  type: CustomDomainType;
};

export type ListWebsiteDomainsByTypeResponsePayload = {
  active: CustomDomainRecord | null;
  pending: CustomDomainRecord | null;
  inactive: CustomDomainRecord[];
};

export type ListDNSRecordsInput = { agencyId: string; domain: string; platform: CustomDomainPlatformType };

export type ListDNSRecordsResponsePayload = {
  platform: DNSRecord;
  support: DNSRecord;
  email: DNSRecord[];
};

export type CheckDNSInput = { host: string; expectedValue: string; type: DNSRecordType };

export type CheckDNSResponsePayload = {
  success: boolean;
  message: string;
};

export type AgencyProvisionInput = { domain: string; type: CustomDomainTarget; agencyId: string };

export type AgencyProvisionResponsePayload = { message: string };

export type CreateSenderEmailInput = {
  companyId: string;
  email: string;
  type: CustomDomainPlatformType;
  senderName?: string;
  skipActivation?: boolean;
};

export enum SenderEmailStatus {
  active = 'active',
  pending = 'pending',
  inactive = 'inactive',
}

export type SenderEmail = {
  id: number;
  email: string;
  type: CustomDomainPlatformType;
  domain: string;
  status: SenderEmailStatus;
  name: string;
  createdAt: string;
  companyId: string;
};

export type ListSenderEmailsInput = {
  companyId: string;
};

export type ListSenderEmailsResponsePayload = {
  active: SenderEmail | null;
  pending: SenderEmail | null;
  inactive: SenderEmail[];
};

export type DeleteSenderEmailsInput = {
  companyId: string;
  senderEmailId: number;
};

export type DeleteSenderEmailsResponsePayload = {
  success: boolean;
};

export type ActivateSenderEmailsInput = {
  companyId: string;
  senderEmailId: number;
};

export type ActivateSenderEmailsResponsePayload = {
  success: boolean;
};

export type CancelPendingSenderEmailsInput = {
  companyId: string;
  senderEmailId: number;
};

export type UpdateCustomSenderNameInput = {
  companyId: string;
  senderEmailId: number;
  senderName: string;
};

export type GetTargetedDNSRecordsInput = {
  domain: string;
  platform: CustomDomainPlatformType;
  target: CustomDomainTarget;
};
